import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'banners';
export const bannersActions = makeActions(MODEL_NAME);

export const getAllBanners = bannersActions.getAll;
export const editBanners = bannersActions.edit;
export const createBanners = bannersActions.create;
export const getByIdBanners = bannersActions.getDataById;
